<template>
    <tr class="border-t border-gray-200 dark:border-gray-800">
        <td class="px-2 text-sm whitespace-normal text-gray-900 dark:text-gray-100">
            <p>{{ newLoyer.bien.libelle }}</p>
            <span class="text-xs text-gray-400">{{ formatMonth(newLoyer.month) }} {{ newLoyer.year }}</span>
            <p v-if="newLoyer.periode_debut && newLoyer.periode_fin" class="text-orange-500 italic text-xs">
                Prorata du {{ formatDate(newLoyer.periode_debut) }} au {{ formatDate(newLoyer.periode_fin) }}
            </p>
        </td>
        <td class="px-2 text-sm font-medium whitespace-nowrap text-gray-700 dark:text-gray-300 py-1">
            <div
                class="flex justify-start items-center rounded-md my-1"
                v-for="habitant of newLoyer.habitants" :key="habitant.uuid"
            >
                <user-icon :user="habitant.locataire"/>
                <div class="ml-3">
                    <p class="text-sm font-normal text-gray-900 dark:text-gray-100">
                        {{habitant.locataire.prenom}} {{habitant.locataire.nom}}
                    </p>
                    <p class="text-sm text-gray-500 dark:text-gray-400">{{habitant.locataire.contact_email}}</p>
                </div>
            </div>
        </td>

        <td class="px-2 text-sm whitespace-nowrap">
            <span 
                class="flex items-center justify-end"
            >
                <button class="btn-success mr-1" @click="$refs.editNewLoyerModal.openModal(newLoyer)">
                    <font-awesome-icon class="text-sm" :icon="['fa', 'check']" />
                </button>
                <button class="btn-danger px-4" @click.prevent="confirmRemoveNewLoyer()">
                    <font-awesome-icon class="text-sm text-white" :icon="['fa', 'times']" />
                </button>
            </span>
        </td>
    </tr>
    <EditNewLoyerModal
        ref="editNewLoyerModal"
        @handleUpdateList="$emit('refresh')"
    />
</template>

<script>

import EditNewLoyerModal from './../../modal/dashboard/new-loyer/EditNewLoyerModal';

export default {
    components: {
        EditNewLoyerModal
    },

    emits: ['refresh'],

    props: {
        newLoyer: {
            type: Object,
            default() {
                return {}
            }
        },
    },

    methods: {
        confirmRemoveNewLoyer() {
            this.$confirm({
                variant: 'danger',
                title: 'Supprimer ce loyer',
                message: "Vous êtes sur le point de supprimer ce loyer. Cette action est irréversible, en êtes-vous sûr ?",
                confirmText: 'Supprimer',
                action: () => this.removeNewLoyer(),
            });
        },

        async removeNewLoyer() {
            if (!this.newLoyer.bien.uuid || !this.newLoyer.uuid) {
                return;
            }

            await this.$api.bien.removeLoyer(this.newLoyer.bien.uuid, this.newLoyer.uuid)
            .then(async () => {
                this.$toast({title: 'Succès', description: "Le loyer à bien été supprimé."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.$emit('refresh')
        },
    }
};
</script>
